import { BuyInBulkSchoolImage } from 'assets';
import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import Card, { ICard } from '@/components/Partnership/Common/Card';
import Layout from '@/components/Partnership/Common/Card/Layout';
import Header from '@/components/Partnership/Common/Header';
interface Props {
  className?: string;
}
const ForSchoolsSection: FC<Props> = ({ className }) => {
  const list: ICard[] = [
    {
      id: 1,
      title: 'Buy in Bulk',
      button: {
        link: 'https://docs.google.com/forms/d/e/1FAIpQLSe5bc5RTzDeboAf7yy3hLDPpjfWvGCNuVaVE2UCN3LQRxuzQQ/viewform',
        text: 'Contact Us →',
      },
      image: BuyInBulkSchoolImage,
      pointers: [
        'Affordable pricing for institutions',
        'Ideal for classrooms & libraries',
      ],
      tags: ['LINKEDIN', 'META', 'OTHERS'],
    },
  ];
  return (
    <div className={twMerge('', className)}>
      <Header title='For Schools' className='md:pb-4 mb-[18px]' />
      <Layout>
        {list.map((i) => (
          <Card key={i.id} card={i} />
        ))}
      </Layout>
    </div>
  );
};

export default ForSchoolsSection;
